import { useCurrentUser } from "./useCurrentUser";
import { CHAT_STATUS, ChatType } from "../types/Chat.ts";

export function useChatController() {
  const currentUser = useCurrentUser();

  const getChatState = (chat: ChatType) =>
    chat.users.find((val) => val.userId === currentUser);

  const getCorrespondent = (chat: ChatType) =>
    chat.users.find((val) => val.userId !== currentUser);

  const chatIsValid = (chat: ChatType) =>
    !chat.users.some((val) => val.state !== CHAT_STATUS.ACTIVE);

  return {
    getChatState: getChatState,
    getCorrespondent: getCorrespondent,
    chatIsValid: chatIsValid,
  };
}
